/**
 * App Config File
 */

export default {
  appLogo: '/static/img/site-logo.png',
  copyrightText: 'Ayres IM © 2020 All Rights Reserved.',
  enableUserTour: process.env.NODE_ENV === 'production',
  appName: process.env.VUE_APP_NAME_APP,
  urlServer: process.env.VUE_APP_URL_SERVER,
  urlApi: process.env.VUE_APP_URL_API,
  env: process.env.VUE_APP_ENV
}
